import { cn } from '@/lib/cn'
import { backgroundImage } from '@/lib/format'

interface AvatarProps {
  src: string | null | undefined
  className?: string
  /** Describes who the avatar belongs to, for assistive tech. */
  label?: string
}

/**
 * The Quasar screens repeated this six times as an inline ternary that built a
 * `style` string and toggled the dashed placeholder border:
 *
 *   :style="!!x ? 'border: none; background-image: url(' + x.src + ');' : ''"
 */
export function Avatar({ src, className, label }: AvatarProps) {
  return (
    <div
      className={cn('background-cover', src && 'filled', className)}
      style={backgroundImage(src)}
      role="img"
      aria-label={label ?? 'Avatar'}
    />
  )
}
